import { render, staticRenderFns } from "./AITemplateDescriptionLayout.vue?vue&type=template&id=3a39b1a5&scoped=true"
import script from "./AITemplateDescriptionLayout.vue?vue&type=script&lang=js"
export * from "./AITemplateDescriptionLayout.vue?vue&type=script&lang=js"
import style0 from "./AITemplateDescriptionLayout.vue?vue&type=style&index=0&id=3a39b1a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a39b1a5",
  null
  
)

export default component.exports